<template>
  <section class="hero is-info is-fullheight">
    <div class="hero-body">
      <div class="container">
        <div class="has-text-centered">
          <router-link to="/">
            <img src="/static/img/logo/logo.svg" alt="logo" width="121"/>
          </router-link>
        </div>
        <h1 class="title has-text-centered">
          We are currently performing routine maintenance. We will be back shortly.
        </h1>
      </div>
    </div>
  </section>
</template>
<script>
/* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape */

export default {
  name: 'Mip',
  metaInfo () {
    return {
      title: this.metaTitle
    }
  }
}
</script>
<style scoped>
h1 {
  font-size: 1.3rem;
  margin-bottom: 1.8rem;
}

.hero.is-info {
  background-color: #ffffff;
  color: #4a4a4a;
}

.hero .title {
  color: #4a4a4a;
}
</style>



// WEBPACK FOOTER //
// src/pages/Mip.vue